enum TipoCadastro {
    Fornecedor = 0,
    Cliente = 1
}

export default TipoCadastro;